"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_ui_1 = require("@sport-thieme/react-ui");
var util_localization_1 = require("@sport-thieme/util-localization");
var useStyles = (0, react_ui_1.makeStyles)(function (theme) { return ({
    content: {
        padding: theme.spacing(3),
    },
}); });
var FeedbackComponent = function () { return (react_1.default.createElement("div", null,
    react_1.default.createElement(react_ui_1.H4, null, (0, util_localization_1.localize)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["An error has occurred"], ["An error has occurred"])))),
    react_1.default.createElement(react_ui_1.P, null, (0, util_localization_1.localize)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["Please contact support"], ["Please contact support"])))),
    react_1.default.createElement(react_ui_1.Caption, null,
        react_1.default.createElement("a", { href: "https://jira.sport-thieme.de/", target: "_blank", rel: "noopener noreferrer" }, "Jira")))); };
function ErrorFeedback(_a) {
    var _b = _a.component, component = _b === void 0 ? FeedbackComponent : _b, error = _a.error, variables = _a.variables;
    var Feedback = component;
    var classes = useStyles();
    if (process.env.NODE_ENV === "development") {
        var errorMessage_1 = error.message, networkError_1 = error.networkError, graphQLErrors_1 = error.graphQLErrors, extraInfo_1 = error.extraInfo, stack_1 = error.stack;
        var Empty_1 = function () { return react_1.default.createElement("span", null, "empty"); };
        Feedback = function () { return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_ui_1.H4, null, "GraphQL Error"),
            react_1.default.createElement("p", null,
                react_1.default.createElement("strong", null, "Message")),
            react_1.default.createElement("pre", null, String(errorMessage_1) || react_1.default.createElement(Empty_1, null)),
            react_1.default.createElement("p", null,
                react_1.default.createElement("strong", null, "GraphQL Errors")),
            react_1.default.createElement("div", null, graphQLErrors_1.length > 0 ? (graphQLErrors_1.map(function (_a, i) {
                var message = _a.message, extensions = _a.extensions, path = _a.path, stack = _a.stack;
                return (react_1.default.createElement("section", { key: "error_" + (i + 1) },
                    react_1.default.createElement("section", null,
                        react_1.default.createElement("p", null, "Error #" + (i + 1) + ":"),
                        react_1.default.createElement("pre", null,
                            react_1.default.createElement("ul", null,
                                message && react_1.default.createElement("li", null, message),
                                extensions && extensions.category && (react_1.default.createElement("li", null, String(extensions.category)))))),
                    react_1.default.createElement("section", null,
                        react_1.default.createElement("p", null, "Path"),
                        react_1.default.createElement("pre", null, path && path.length > 0 ? (react_1.default.createElement("ul", null, path.map(function (p, j) { return (react_1.default.createElement("li", { key: "path_" + (i + 1) + "_" + (j + 1) }, p)); }))) : (react_1.default.createElement(Empty_1, null)))),
                    stack && (react_1.default.createElement("section", null,
                        react_1.default.createElement("p", null, "Stack"),
                        react_1.default.createElement("pre", null, stack)))));
            })) : (react_1.default.createElement("pre", null,
                react_1.default.createElement(Empty_1, null)))),
            react_1.default.createElement("p", null,
                react_1.default.createElement("strong", null, "Network Error")),
            react_1.default.createElement("pre", null, (networkError_1 && networkError_1.message) || react_1.default.createElement(Empty_1, null)),
            variables && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", null,
                    react_1.default.createElement("strong", null, "Variables")),
                react_1.default.createElement("pre", null, JSON.stringify(variables, null, 4)))),
            react_1.default.createElement("p", null,
                react_1.default.createElement("strong", null, "Extra Info")),
            react_1.default.createElement("pre", null, extraInfo_1 || react_1.default.createElement(Empty_1, null)),
            react_1.default.createElement("p", null,
                react_1.default.createElement("strong", null, "Stack")),
            react_1.default.createElement("pre", null, stack_1 || react_1.default.createElement(Empty_1, null)))); };
    }
    return (react_1.default.createElement("div", { className: classes.content },
        react_1.default.createElement(react_ui_1.Paper, { elevation: 3, withPadding: true },
            react_1.default.createElement(Feedback, null))));
}
exports.default = ErrorFeedback;
var templateObject_1, templateObject_2;
//# sourceMappingURL=ErrorFeedback.js.map